import { Component } from '@angular/core';
import { faExclamationTriangle, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
  standalone: false
})
export class NotFoundComponent {
  icons: { [key: string]: IconDefinition } = {
    faExclamationTriangle,
  };

}
